import WbuMultilineTextInputMapper from '../components/WbuMultilineTextInput/viewer/WbuMultilineTextInput.mapper';
import WbuTextInputMapper from '../components/WbuTextInput/viewer/WbuTextInput.mapper';
import WbuThumbnailsMapper from '../components/WbuThumbnails/viewer/WbuThumbnails.mapper';
import WsrButtonMapper from '../components/WsrButton/viewer/WsrButton.mapper';
import WsrCardMapper from '../components/WsrCard/viewer/WsrCard.mapper';
import WsrCheckboxMapper from '../components/WsrCheckbox/viewer/WsrCheckbox.mapper';
import WsrCustomModalLayoutMapper from '../components/WsrCustomModalLayout/viewer/WsrCustomModalLayout.mapper';
import WsrDatePickerMapper from '../components/WsrDatePicker/viewer/WsrDatePicker.mapper';
import WsrDividerMapper from '../components/WsrDivider/viewer/WsrDivider.mapper';
import WsrDropdownMapper from '../components/WsrDropdown/viewer/WsrDropdown.mapper';
import WsrHeadingMapper from '../components/WsrHeading/viewer/WsrHeading.mapper';
import WsrIconButtonMapper from '../components/WsrIconButton/viewer/WsrIconButton.mapper';
import WsrInfoIconMapper from '../components/WsrInfoIcon/viewer/WsrInfoIcon.mapper';
import WsrInputMapper from '../components/WsrInput/viewer/WsrInput.mapper';
import WsrMessageModalLayoutMapper from '../components/WsrMessageModalLayout/viewer/WsrMessageModalLayout.mapper';
import WsrNumberInputMapper from '../components/WsrNumberInput/viewer/WsrNumberInput.mapper';
import WsrPageMapper from '../components/WsrPage/viewer/WsrPage.mapper';
import WsrPreviewWidgetMapper from '../components/WsrPreviewWidget/viewer/WsrPreviewWidget.mapper';
import WsrTableListItemMapper from '../components/WsrTableListItem/viewer/WsrTableListItem.mapper';
import WsrTextMapper from '../components/WsrText/viewer/WsrText.mapper';
import WsrTextAreaMapper from '../components/WsrTextArea/viewer/WsrTextArea.mapper';
import WsrTextButtonMapper from '../components/WsrTextButton/viewer/WsrTextButton.mapper';
import WsrToggleSwitchMapper from '../components/WsrToggleSwitch/viewer/WsrToggleSwitch.mapper';
import WutAvatarGroupMapper from '../components/WutAvatarGroup/viewer/WutAvatarGroup.mapper';
import WutRadioButtonMapper from '../components/WutRadioButton/viewer/WutRadioButton.mapper';
import ControlTypesMapper from '../.components/ControlTypes/viewer/ControlTypes.mapper';
import SettingsPanelContainerMapper from '../.components/SettingsPanelContainer/viewer/SettingsPanelContainer.mapper';
import WbuAccordionMapper from '../.components/WbuAccordion/viewer/WbuAccordion.mapper';
import WbuBackButtonMapper from '../.components/WbuBackButton/viewer/WbuBackButton.mapper';
import WbuButtonMapper from '../.components/WbuButton/viewer/WbuButton.mapper';
import WbuCheckboxGroupMapper from '../.components/WbuCheckboxGroup/viewer/WbuCheckboxGroup.mapper';
import WbuColorPickerMapper from '../.components/WbuColorPicker/viewer/WbuColorPicker.mapper';
import WbuColorSelectorMapper from '../.components/WbuColorSelector/viewer/WbuColorSelector.mapper';
import WbuCornerRadiusMapper from '../.components/WbuCornerRadius/viewer/WbuCornerRadius.mapper';
import WbuDatePickerMapper from '../.components/WbuDatePicker/viewer/WbuDatePicker.mapper';
import WbuDrillDownMapper from '../.components/WbuDrillDown/viewer/WbuDrillDown.mapper';
import WbuDropdownMapper from '../.components/WbuDropdown/viewer/WbuDropdown.mapper';
import WbuEmptyStateMapper from '../.components/WbuEmptyState/viewer/WbuEmptyState.mapper';
import WbuFontAndColorPickerMapper from '../.components/WbuFontAndColorPicker/viewer/WbuFontAndColorPicker.mapper';
import WbuHorizontalTabsMapper from '../.components/WbuHorizontalTabs/viewer/WbuHorizontalTabs.mapper';
import WbuLeftTextButtonMapper from '../.components/WbuLeftTextButton/viewer/WbuLeftTextButton.mapper';
import WbuNotificationBannerMapper from '../.components/WbuNotificationBanner/viewer/WbuNotificationBanner.mapper';
import WbuNumericInputMapper from '../.components/WbuNumericInput/viewer/WbuNumericInput.mapper';
import WbuRadioButtonGroupMapper from '../.components/WbuRadioButtonGroup/viewer/WbuRadioButtonGroup.mapper';
import WbuRichTextMapper from '../.components/WbuRichText/viewer/WbuRichText.mapper';
import WbuSecondaryMediaMapper from '../.components/WbuSecondaryMedia/viewer/WbuSecondaryMedia.mapper';
import WbuSectionDividerMapper from '../.components/WbuSectionDivider/viewer/WbuSectionDivider.mapper';
import WbuSliderMapper from '../.components/WbuSlider/viewer/WbuSlider.mapper';
import WbuToggleSwitchMapper from '../.components/WbuToggleSwitch/viewer/WbuToggleSwitch.mapper';
import WsrSelectableAccordionMapper from '../.components/WsrSelectableAccordion/viewer/WsrSelectableAccordion.mapper';
import WutAvatarMapper from '../.components/WutAvatar/viewer/WutAvatar.mapper';
import WutColorPickerMapper from '../.components/WutColorPicker/viewer/WutColorPicker.mapper';
import WutTabbedContentMapper from '../.components/WutTabbedContent/viewer/WutTabbedContent.mapper';


const WbuMultilineTextInput = {
  mapper: WbuMultilineTextInputMapper
};

const WbuTextInput = {
  mapper: WbuTextInputMapper
};

const WbuThumbnails = {
  mapper: WbuThumbnailsMapper
};

const WsrButton = {
  mapper: WsrButtonMapper
};

const WsrCard = {
  mapper: WsrCardMapper
};

const WsrCheckbox = {
  mapper: WsrCheckboxMapper
};

const WsrCustomModalLayout = {
  mapper: WsrCustomModalLayoutMapper
};

const WsrDatePicker = {
  mapper: WsrDatePickerMapper
};

const WsrDivider = {
  mapper: WsrDividerMapper
};

const WsrDropdown = {
  mapper: WsrDropdownMapper
};

const WsrHeading = {
  mapper: WsrHeadingMapper
};

const WsrIconButton = {
  mapper: WsrIconButtonMapper
};

const WsrInfoIcon = {
  mapper: WsrInfoIconMapper
};

const WsrInput = {
  mapper: WsrInputMapper
};

const WsrMessageModalLayout = {
  mapper: WsrMessageModalLayoutMapper
};

const WsrNumberInput = {
  mapper: WsrNumberInputMapper
};

const WsrPage = {
  mapper: WsrPageMapper
};

const WsrPreviewWidget = {
  mapper: WsrPreviewWidgetMapper
};

const WsrTableListItem = {
  mapper: WsrTableListItemMapper
};

const WsrText = {
  mapper: WsrTextMapper
};

const WsrTextArea = {
  mapper: WsrTextAreaMapper
};

const WsrTextButton = {
  mapper: WsrTextButtonMapper
};

const WsrToggleSwitch = {
  mapper: WsrToggleSwitchMapper
};

const WutAvatarGroup = {
  mapper: WutAvatarGroupMapper
};

const WutRadioButton = {
  mapper: WutRadioButtonMapper
};

const ControlTypes = {
  mapper: ControlTypesMapper
};

const SettingsPanelContainer = {
  mapper: SettingsPanelContainerMapper
};

const WbuAccordion = {
  mapper: WbuAccordionMapper
};

const WbuBackButton = {
  mapper: WbuBackButtonMapper
};

const WbuButton = {
  mapper: WbuButtonMapper
};

const WbuCheckboxGroup = {
  mapper: WbuCheckboxGroupMapper
};

const WbuColorPicker = {
  mapper: WbuColorPickerMapper
};

const WbuColorSelector = {
  mapper: WbuColorSelectorMapper
};

const WbuCornerRadius = {
  mapper: WbuCornerRadiusMapper
};

const WbuDatePicker = {
  mapper: WbuDatePickerMapper
};

const WbuDrillDown = {
  mapper: WbuDrillDownMapper
};

const WbuDropdown = {
  mapper: WbuDropdownMapper
};

const WbuEmptyState = {
  mapper: WbuEmptyStateMapper
};

const WbuFontAndColorPicker = {
  mapper: WbuFontAndColorPickerMapper
};

const WbuHorizontalTabs = {
  mapper: WbuHorizontalTabsMapper
};

const WbuLeftTextButton = {
  mapper: WbuLeftTextButtonMapper
};

const WbuNotificationBanner = {
  mapper: WbuNotificationBannerMapper
};

const WbuNumericInput = {
  mapper: WbuNumericInputMapper
};

const WbuRadioButtonGroup = {
  mapper: WbuRadioButtonGroupMapper
};

const WbuRichText = {
  mapper: WbuRichTextMapper
};

const WbuSecondaryMedia = {
  mapper: WbuSecondaryMediaMapper
};

const WbuSectionDivider = {
  mapper: WbuSectionDividerMapper
};

const WbuSlider = {
  mapper: WbuSliderMapper
};

const WbuToggleSwitch = {
  mapper: WbuToggleSwitchMapper
};

const WsrSelectableAccordion = {
  mapper: WsrSelectableAccordionMapper
};

const WutAvatar = {
  mapper: WutAvatarMapper
};

const WutColorPicker = {
  mapper: WutColorPickerMapper
};

const WutTabbedContent = {
  mapper: WutTabbedContentMapper
};


export const components = {
  ['WbuMultilineTextInput']: WbuMultilineTextInput,
  ['WbuTextInput']: WbuTextInput,
  ['WbuThumbnails']: WbuThumbnails,
  ['WsrButton']: WsrButton,
  ['WsrCard']: WsrCard,
  ['WsrCheckbox']: WsrCheckbox,
  ['WsrCustomModalLayout']: WsrCustomModalLayout,
  ['WsrDatePicker']: WsrDatePicker,
  ['WsrDivider']: WsrDivider,
  ['WsrDropdown']: WsrDropdown,
  ['WsrHeading']: WsrHeading,
  ['WsrIconButton']: WsrIconButton,
  ['WsrInfoIcon']: WsrInfoIcon,
  ['WsrInput']: WsrInput,
  ['WsrMessageModalLayout']: WsrMessageModalLayout,
  ['WsrNumberInput']: WsrNumberInput,
  ['WsrPage']: WsrPage,
  ['WsrPreviewWidget']: WsrPreviewWidget,
  ['WsrTableListItem']: WsrTableListItem,
  ['WsrText']: WsrText,
  ['WsrTextArea']: WsrTextArea,
  ['WsrTextButton']: WsrTextButton,
  ['WsrToggleSwitch']: WsrToggleSwitch,
  ['WutAvatarGroup']: WutAvatarGroup,
  ['WutRadioButton']: WutRadioButton,
  ['ControlTypes']: ControlTypes,
  ['SettingsPanelContainer']: SettingsPanelContainer,
  ['WbuAccordion']: WbuAccordion,
  ['WbuBackButton']: WbuBackButton,
  ['WbuButton']: WbuButton,
  ['WbuCheckboxGroup']: WbuCheckboxGroup,
  ['WbuColorPicker']: WbuColorPicker,
  ['WbuColorSelector']: WbuColorSelector,
  ['WbuCornerRadius']: WbuCornerRadius,
  ['WbuDatePicker']: WbuDatePicker,
  ['WbuDrillDown']: WbuDrillDown,
  ['WbuDropdown']: WbuDropdown,
  ['WbuEmptyState']: WbuEmptyState,
  ['WbuFontAndColorPicker']: WbuFontAndColorPicker,
  ['WbuHorizontalTabs']: WbuHorizontalTabs,
  ['WbuLeftTextButton']: WbuLeftTextButton,
  ['WbuNotificationBanner']: WbuNotificationBanner,
  ['WbuNumericInput']: WbuNumericInput,
  ['WbuRadioButtonGroup']: WbuRadioButtonGroup,
  ['WbuRichText']: WbuRichText,
  ['WbuSecondaryMedia']: WbuSecondaryMedia,
  ['WbuSectionDivider']: WbuSectionDivider,
  ['WbuSlider']: WbuSlider,
  ['WbuToggleSwitch']: WbuToggleSwitch,
  ['WsrSelectableAccordion']: WsrSelectableAccordion,
  ['WutAvatar']: WutAvatar,
  ['WutColorPicker']: WutColorPicker,
  ['WutTabbedContent']: WutTabbedContent
};


// temporary export
export const version = "1.0.0"
